import {
	ADMINADDORUPDATEKYCPROOF_SUCCESS,
	ADMINADDORUPDATEKYCPROOF_FAILED,
	RESET_ADMINADDORUPDATEKYCPROOF,
	LOADING_ADMINADDORUPDATEKYCPROOF,
	NETWORK_ERROR_ADMINADDORUPDATEKYCPROOF
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINADDORUPDATEKYCPROOF:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINADDORUPDATEKYCPROOF_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINADDORUPDATEKYCPROOF_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINADDORUPDATEKYCPROOF:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINADDORUPDATEKYCPROOF:
			return (state = initialState);
		default:
			return state;
	}
};
